import { render, staticRenderFns } from "./QuickInfoQuery.vue?vue&type=template&id=10427b30&"
import script from "./QuickInfoQuery.vue?vue&type=script&lang=js&"
export * from "./QuickInfoQuery.vue?vue&type=script&lang=js&"
import style0 from "./QuickInfoQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickInfoQuery.vue"
export default component.exports